/* Inner Bazar — Shared homepage interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';

  function createCarousel(root, opts) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(opts.slideSelector));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll(opts.dotSelector));
    var prevBtn = root.querySelector(opts.prevSelector);
    var nextBtn = root.querySelector(opts.nextSelector);
    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) {
        if (opts.mode === 'transform') {
          s.style.transform = '';
        } else {
          s.classList.toggle('is-active', si === index);
        }
      });
      if (opts.mode === 'transform') {
        root.querySelector(opts.trackSelector).style.transform = 'translateX(-' + (index * 100) + '%)';
      }
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
      });
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function startAuto() {
      if (reduceMotion || !opts.autoplay) return;
      stopAuto();
      timer = setInterval(next, opts.interval || 6000);
    }
    function stopAuto() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAuto(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { show(di); startAuto(); });
    });

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    show(0);
    startAuto();
  }

  function initHero(section) {
    createCarousel(section, {
      slideSelector: '.ib-hero__slide',
      dotSelector: '.ib-hero__dot',
      prevSelector: '.ib-hero__nav--prev',
      nextSelector: '.ib-hero__nav--next',
      mode: 'class',
      autoplay: true,
      interval: 6000
    });
  }

  function initTestimonials(section) {
    createCarousel(section, {
      slideSelector: '.ib-testimonials__slide',
      dotSelector: '.ib-testimonials__dot',
      trackSelector: '.ib-testimonials__track',
      mode: 'transform',
      autoplay: true,
      interval: 7000
    });
  }

  function boot() {
    document.querySelectorAll('[data-ib-hero]').forEach(initHero);
    document.querySelectorAll('[data-ib-testimonials]').forEach(initTestimonials);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-ib-hero]');
    var testi = e.target.querySelector('[data-ib-testimonials]');
    if (hero) initHero(hero);
    if (testi) initTestimonials(testi);
  });
})();